import { InputTextType } from "../Enum/InputTextType";
import { Utils } from "../Utils/Utils";
import ValidationMessages from "../Data/ValidationMessages";
import { FieldType } from "../Enum/FieldType";
export default class Control {
    constructor(field) {
        this.type = InputTextType.text;
        this.notValidClass = "not-valid";
        this.validClass = "valid";
        this.hidden = false;
        this.initialValue = null;
        this.group = null;
        this.field = field;
        if (this.field && this.field.form && this.field.form.values) {
            this.initialValue = this.field.form.values[this.field.internalId];
        }
        this.field.isCustomValid = true;
    }
    canRender() {
        var _a;
        if (!this.field.displayIf) {
            return true;
        }
        // Check if current field is related to a parent field and if it should show/hide based on parent selected value
        const currentParentField = this.field.form.fields.find((f) => f.internalId === this.field.displayIf.fieldInternalId);
        if (currentParentField) {
            let parentFieldValue = (_a = currentParentField.control.initialValue) === null || _a === void 0 ? void 0 : _a.valueId;
            return this.field.displayIf.value === parentFieldValue;
        }
        return true;
    }
    render() {
        const preview = this.field.form ? this.isPreviewMode() : false;
        if (preview && !this.canRender())
            return "";
        return (`<div class=form-control id="control_${this.field.internalId}">` +
            (Utils.isOk(this.field.displayName) && this.field.displayName !== ""
                ? `<label for="${this.field.internalId}${this.field.fieldType === FieldType.Selection ? "_select" : ""}">${this.checkTextVariables(this.field.displayName)}` +
                    (this.isRequired() ? "<span class=required>*</span>" : "") +
                    "</label>"
                : "") +
            (Utils.isOk(this.field.hintAbove) && this.field.hintAbove !== ""
                ? `<span class=hint-above>${this.checkTextVariables(this.field.hintAbove)}</span>`
                : "") +
            '<div class="form-control-container">' +
            (preview ? this.renderPreview() : this.renderField()) +
            "</div>" +
            (Utils.isOk(this.field.hintBelow) && this.field.hintBelow !== ""
                ? `<span class=hint-below>${this.checkTextVariables(this.field.hintBelow)}</span>`
                : "") +
            "</div>");
    }
    checkTextVariables(str) {
        const variables = this.field.form.options.textVariables;
        if (variables) {
            for (let key in variables) {
                str = str.replace(new RegExp(`%${key}%`, "g"), variables[key]);
            }
        }
        return str;
    }
    hide() {
        var _a;
        this.hidden = true;
        (_a = this.formControl()) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
    }
    show() {
        var _a;
        this.hidden = false;
        (_a = this.formControl()) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
    }
    repeat(number) { }
    renderField() {
        return "";
    }
    renderPreview() {
        var _a;
        return `<span>${(_a = this.initialValue) !== null && _a !== void 0 ? _a : ""}</span>`;
    }
    isRequired() {
        return Utils.isOk(this.field.isRequired)
            ? this.field.isRequired.staticValue
                ? true
                : false
            : false;
    }
    formControl() {
        return Utils.closest(this.getInputElement(), ".form-control");
    }
    getInputElement() {
        return document.getElementById(this.field.internalId);
    }
    getRawValue() {
        return this.getValue();
    }
    getValue() {
        if (this.hidden)
            return null;
        try {
            return this.getInputElement().value;
        }
        catch (_a) {
            return null;
        }
    }
    hasValue() {
        const thisValue = this.getRawValue();
        return thisValue !== "";
    }
    clearValidationMessages() {
        this.field.validationMessages = [];
    }
    addValidationMessage(message) {
        var _a;
        (_a = this.field.validationMessages) === null || _a === void 0 ? void 0 : _a.push(Utils.format(message, this.field.displayName));
    }
    /**
     * Returns true if the control is valid
     */
    isValid() {
        return this.field.isValid;
    }
    /**
     * Validate the control and adds a messgae for each invalid validation
     * @param clearValidationMessages boolean if true, it will clear all previous validation messages, by default this is true
     * @param ghostMode default: false, if true, the fields will not show any validation by adding valid or removing invalid class
     */
    validate(clearValidationMessages = true, ghostMode = false) {
        this.field.isValid = false;
        if (clearValidationMessages)
            this.clearValidationMessages();
        if (this.hidden)
            return (this.field.isValid = true);
        const thisValue = this.getRawValue();
        const thisFormControl = this.formControl();
        if (Utils.isOk(thisFormControl)) {
            if (!ghostMode) {
                thisFormControl.classList.remove(this.notValidClass);
                thisFormControl.classList.remove(this.validClass);
            }
            if (this.isRequired() && (!Utils.isOk(thisValue) || thisValue.trim() === "")) {
                if (!ghostMode)
                    this.addValidationMessage(ValidationMessages.required());
            }
            else {
                //this should be combined validatioin between normal validation and custom like email, number, etc..
                this.field.isValid = this.field.isCustomValid;
            }
            //TODO: add here other validations
            if (!ghostMode) {
                if (!this.isValid()) {
                    thisFormControl.classList.add(this.notValidClass);
                }
                else if (this.getRawValue()) {
                    thisFormControl.classList.add(this.validClass);
                }
            }
        }
        return this.isValid();
    }
    onFocus() {
        var _a;
        const hintBelow = (_a = this.formControl()) === null || _a === void 0 ? void 0 : _a.querySelector(".hint-below");
        if (hintBelow)
            hintBelow.classList.add("visible");
    }
    onBlur() {
        var _a;
        const hintBelow = (_a = this.formControl()) === null || _a === void 0 ? void 0 : _a.querySelector(".hint-below");
        if (hintBelow)
            hintBelow.classList.remove("visible");
        this.validate();
    }
    onChange(validate = true) {
        if (validate) {
            this.validate();
            this.field.form.validateGroup(this.field.group);
        }
        if (this.field.onChange)
            this.field.onChange(this);
        this.checkForLinkedControls();
    }
    afterRender() {
        if (this.field.repeatForFieldInternalId) {
        }
        if (this.field.displayIf)
            this.hide();
        this.onChange(false);
    }
    checkForLinkedControls() {
        this.checkForDisplayIf();
        this.checkForRepeat();
    }
    checkForRepeat() {
        //TODO: repeated controls
    }
    checkForDisplayIf() {
        // Check if current field is related to a parent field and if it should show/hide based on parent selected value
        // This case is usually valid in edit mode (reuse, saved)
        const currentParentField = this.field.form.fields.find((f) => { var _a; return f.internalId === ((_a = this.field.displayIf) === null || _a === void 0 ? void 0 : _a.fieldInternalId); });
        if (currentParentField) {
            let parentFieldValue = currentParentField.control.getRawValue();
            if (this.field.displayIf.value === parentFieldValue) {
                this.field.control.show();
            }
            else {
                this.field.control.hide();
            }
        }
        // Check if current field has related children fields in order to show/hide them based on selected value
        // This case is usually valid on parent selection changed
        const currentChildrenFields = this.field.form.fields.filter((f) => f.displayIf && f.displayIf.fieldInternalId === this.field.internalId);
        if (currentChildrenFields && currentChildrenFields.length > 0) {
            const rawValue = this.getRawValue();
            currentChildrenFields.map((field) => {
                if (field.displayIf.value === rawValue)
                    field.control.show();
                else
                    field.control.hide();
            });
        }
    }
    isPreviewMode() {
        return this.field.form.options.previewMode;
    }
    ///Static region
    static getFormControl(ev) {
        let currentField = ev.currentTarget;
        if (!currentField.hasAttribute("data-main"))
            currentField = Utils.closest(currentField, "[data-main]");
        return currentField;
    }
}
